import { motion } from 'framer-motion'
import { SCENES_2D } from './Scene2DLayer'
import { SCENE_LABELS } from './SceneHUD'
import { accentFor, EASE } from './scenes2d/theme'
import { CVControls } from './CVControls'

// Mobile alternative to the desktop cross-fade experience: every chapter sits
// in normal document flow and scrolls natively, instead of cross-fading inside
// a fixed-viewport layer driven by GSAP ScrollTrigger. This sidesteps the
// fixed/inset:0 sizing issues that show up on phone browsers (Chrome, in-app
// WebViews) with dynamic chrome and narrow viewports.
export function CVExplainerMobile() {
  return (
    <div style={{ position: 'relative', background: '#030309' }}>
      {/* Each scene's root div is authored for the fixed-viewport desktop crossfade
          (position: absolute; inset: 0; overflowY: auto). On mobile that turns the
          chapter's content box into its own scroll container, decoupled from page
          scroll. Neutralize it so content sizes naturally and the page scrolls once. */}
      <style>{`
        .cv-scene-mount > div:first-child {
          position: static !important;
          inset: auto !important;
          overflow: visible !important;
          height: auto !important;
          min-height: 0 !important;
        }
      `}</style>
      <div style={{
        position: 'fixed', top: 0, left: 0, right: 0, zIndex: 50,
        padding: '16px clamp(16px, 5vw, 32px)',
        fontFamily: "'Clash Display', sans-serif",
        fontSize: 13, fontWeight: 700, letterSpacing: '0.04em',
        color: 'rgba(255,255,255,0.9)',
        background: 'linear-gradient(180deg, rgba(3,3,9,0.85), transparent)',
        pointerEvents: 'none',
      }}>
        Computer Vision
      </div>

      {SCENES_2D.map((Scene, i) => {
        const accent = accentFor(i)
        return (
          <motion.section
            key={i}
            initial={{ opacity: 0, y: 24 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, amount: 0.25 }}
            transition={{ duration: 0.6, ease: EASE }}
            style={{
              position: 'relative',
              minHeight: '100svh',
              display: 'flex',
              flexDirection: 'column',
              justifyContent: 'center',
              padding: '64px 0 32px',
            }}
          >
            <div style={{
              padding: '0 clamp(16px, 5vw, 24px)', marginBottom: 8,
              fontFamily: "'JetBrains Mono', monospace",
              fontSize: 10, letterSpacing: '0.22em', textTransform: 'uppercase',
              color: accent, display: 'flex', alignItems: 'center', gap: 7,
            }}>
              <div style={{ width: 18, height: 1, background: accent, opacity: 0.7 }} />
              Chapter {String(i + 1).padStart(2, '0')} · {SCENE_LABELS[i]}
            </div>

            <div className="cv-scene-mount" style={{ position: 'relative' }}>
              <Scene />
            </div>

            {i === 4 && (
              <div style={{ padding: '16px clamp(16px, 5vw, 24px) 0' }}>
                <CVControls mobileInline />
              </div>
            )}
          </motion.section>
        )
      })}
    </div>
  )
}
